module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-159.9c44b1e.woff2";